module.exports = __webpack_public_path__ + "static/img/M-4.656f749.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mga/M-4.png
// module id = oLod
// module chunks = 0